const INITIAL_STATE = {
	loading: false,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, { type, payload }) => {
	switch (type) {
		case 'APPLICATION_LOADER':
			return {
                ...state,
                loading: payload
            };
		default:
			return state;
	}
};
